<template>
  <div class="lifestyle-container">
    <input type="file" ref="fileInput" style="display:none;" @change="processImg($event)">
    <draggable
      class="lifestyle-draggable"
      @start="drag=true"
      @end="drag=false"
      v-model="initialOrder"
      @change="reorderItems"
      v-if="initialOrder.length !== 0"
    >
      <div v-for="(item,key) in initialOrder" class="card" :key="key">
        <div class="image-bg flex center-flex">
          <img v-if="!item.image" :src="item.tempImage" class="object-fit lazyload-images loaded">
          <div v-if="item.image" class="new-image-container">
            <img :src="item.image" class="new-image">
            <div class="new-image-details">
              <a v-if="item.image" @click="deleteImage(item.image,key)">Remove Item</a>
            </div>
          </div>
        </div>
        <h3
          v-if="!showEditText || currentIndex !== key"
          @click="selectTextInput(key)"
        >{{item.title}}</h3>
        <form v-on:submit.prevent="getText(key)">
          <input
            v-show="showEditText && currentIndex === key"
            type="text"
            class="title-input"
            ref="titleInput"
            :placeholder="item.title"
            v-model="form.newTitle"
            @blur="showEditText = false"
            required
            v-focus
          >
        </form>
        <div class="icon-container">
          <svg
            @click="selectImg(key)"
            xmlns="http://www.w3.org/2000/svg"
            class="add-photo"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
            ></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="draggable-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0V0z"></path>
            <path
              d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
            ></path>
          </svg>
          <div class="remove-x" @click="removeItem(key)">&times;</div>
        </div>
      </div>
    </draggable>
    <div class="placeholder flex" v-if=" initialOrder.length < maxItems">
      <div v-for="i in limit" :key="i">
        <div class="card">
          <div class="image-bg flex center-flex">
            <img :src="i" class="lazyload-images">
          </div>
          <h3>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ex.</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import gridX from "./gridX";
import draggable from "vuedraggable";
export default {
  props: ["selectedItem", "currentWidget", "mode", "maxItems", "storage"],
  components: { gridX, draggable },
  data() {
    return {
      previewImage: "",
      columns: "1fr",
      initialOrder: [],
      finalOrder: "",
      limit: this.maxItems,
      isLoading: false,
      showEditText: false,
      form: {
        newTitle: ""
      }
    };
  },
  created() {
    // Might change this to vue.set to make copy of array of objects
    this.initialOrder = this.currentWidget.items
      ? JSON.parse(JSON.stringify(this.currentWidget.items))
      : [];
    this.limit = this.limit - this.initialOrder.length;
  },
  directives: {
    focus: {
      update: function(el) {
        el.focus();
      }
    }
  },
  methods: {
    updateList: function() {
      // Spread updates items in v-for loop above (https://vuejs.org/v2/guide/list.html#Caveats)
      this.initialOrder = [...this.initialOrder];
    },
    selectTextInput: function(index) {
      this.form.newTitle = "";
      this.showEditText = true;
      this.currentIndex = index;
    },
    getText: function(index) {
      this.initialOrder[index].title = this.form.newTitle;
      this.updateList();
      this.finalOrder = this.initialOrder;
      this.reorderItems();
      this.currentIndex = null;
      this.showEditText = false;
    },
    newItem: function() {
      this.initialOrder.unshift({
        title: this.selectedItem.title,
        tempImage: this.selectedItem.image,
        postid: this.selectedItem.postid
      });
      this.reorderItems();
      this.limit = this.limit - 1;
    },
    reorderItems: function() {
      this.finalOrder = this.initialOrder;
      this.$emit("orderChange", this.finalOrder);
    },
    removeItem: function(index) {
      this.initialOrder.splice(index, 1);
      this.reorderItems();
      this.limit = this.limit + 1;
    },
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    deleteImage: function(image, index) {
      let storageRef = this.storage.refFromURL(`${image}`);
      storageRef
        .delete()
        .then(() => {
          // File deleted successfully
          console.log("file was deleted!");
          delete this.initialOrder[index].image;
          this.finalOrder = this.initialOrder;
          this.updateList();
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectImg: function(index) {
      this.$refs.fileInput.click();
      this.currentIndex = index;
    },
    processImg: function(event) {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        let storageRef = this.storage.ref("images/" + this.getFileName(file));
        let fileUpload = storageRef.put(file);
        let url = null;
        fileUpload.on(
          "state_changed",
          snapshot => {
            let percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (percentage < 100) {
              this.isLoading = true;
            } else {
              this.isLoading = false;
            }
          },
          err => {
            console.log(err);
          },
          () => {
            fileUpload.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.initialOrder[this.currentIndex].image = downloadURL;
              this.updateList();
              this.finalOrder = this.initialOrder;
              this.isLoading = false;
              this.$emit("orderChange", this.finalOrder);
            });
          }
        );
      }
    }
  }
};
</script>

<style scoped>
.new-image-container {
  position: relative;
  border-radius: 0;
}
.upload-image {
  z-index: 2;
  padding: 0;
  margin: 0;
}
.new-image-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: opacity 0.2;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 50%;
}
.new-image-details a {
  color: #fff;
  cursor: pointer;
  border: solid #fff 2px;
  padding: 1em;
  font-weight: 700;
}
.new-image-details p {
  color: #fff;
}
.new-image-details:hover {
  opacity: 1;
}
.lifestyle-container {
  display: flex;
  justify-content: center;
}

.placeholder .card {
  cursor: default;
}

.icon-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.draggable-icon {
  transform: rotate(90deg);
}

.card {
  margin: 0 1.5em 1em 0;
  max-width: 318px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  padding-bottom: 0.5em;
  cursor: grab;
}

.lifestyle-draggable {
  display: flex;
  justify-content: center;
}

.title-input {
  display: block;
  margin: 1em auto;
  width: 90%;
}

.add-photo,
.remove-x {
  font-size: 2em;
  cursor: pointer;
}

h3 {
  text-align: center;
  border: none;
  font-family: Lora, Cambria, Times, Times New Roman, serif;
  margin: 1em;
  font-size: 16px;
  cursor: pointer;
}
.upload-preview {
  height: 50px;
  width: 50px;
  position: relative;
  overflow: hidden;
}

.upload-preview img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: relative;
}

.input-box.bacteria-image-upload {
  height: 60px;
  margin-bottom: 0;
}
.image-bg {
  max-width: 318px;
  max-height: 318px;
  padding: 1em;
  background: #6384ea;
  background: url("../../assets/Pattern_Blue.svg");
  background-size: cover;
  margin: 0;
}
.image-bg img {
  border-radius: 50%;
  width: 280px;
  height: 280px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// lifestylePreview.vue?9b24d948